import React, { useMemo } from 'react';
import UsersContext from '../../../../contexts/UsersContext';
import useUsers from './useUsers';
import useStaffUsers from './useStaffUsers';
import userTypeCheckers from './userTypeCheckers';

const UsersProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { isLoadingUsers, users } = useUsers();
  const { isLoadingStaffUsers, staffUsers } = useStaffUsers();
  // Derived in the same render as isLoading, so a consumer never sees
  // isLoading=false alongside a stale (empty) user list.
  const allUsers = useMemo((): UserManagement.User[] => {
    return [...staffUsers, ...users];
  }, [staffUsers, users]);

  const signedUpAndPendingUsers = useMemo((): (
    | UserManagement.SignedUpUser
    | UserManagement.PendingUser
  )[] => {
    return allUsers
      .filter(userTypeCheckers.isSignedUpOrPendingUser)
      .filter((u) => !u.isDeleted);
  }, [allUsers]);

  return (
    <UsersContext.Provider
      value={{
        allUsers,
        staffUsers,
        signedUpAndPendingUsers,
        isLoading: isLoadingUsers || isLoadingStaffUsers,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export default UsersProvider;
